import { parseElementFromString } from 'anodum';
import getCustomTextColorsStylesheet from './get-custom-text-color-stylesheet';
import { connectedStore } from '../../../store';
import globals from '../../../globals';
import view from '../../../view';
import constants from '../../constants';
import template from '../../../template';

const { TEXT_COLOR_OPTIONS_VARIABLE } = constants;

const updateCustomColorStylesheetInGlobal = (toUpdateMeta = true) => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = template.selectors.getVariables(state);
  const { id, querySelector, globalId } = variables[TEXT_COLOR_OPTIONS_VARIABLE][0];
  const headerCodeGlobal = globals.selectors.getGlobal(state, globalId);
  const liveDom = view.accessors.getLiveDocument();
  const textColorStylesheet = getCustomTextColorsStylesheet();
  const styleString = Array.from(textColorStylesheet.cssRules)
    .map(({ cssText }) => cssText)
    .join('');

  if (toUpdateMeta) {
    globals.operations.changeGlobalContent(
      globalId,
      (globalFragment) => {
        const styleTag = globalFragment.querySelector(querySelector);
        styleTag.innerHTML = styleString;
        return globalFragment;
      },
      false
    );
  }

  const liveHeaderCodeGlobalNode = liveDom.querySelector(
    `ws-global[src*="${headerCodeGlobal.source}"]`
  );
  const stylesheetWrapper = liveHeaderCodeGlobalNode.querySelector(`#${id}`);
  stylesheetWrapper.querySelector(querySelector).innerHTML = styleString;

  const serializedGlobal = parseElementFromString(headerCodeGlobal.html);
  serializedGlobal.querySelector(querySelector).innerHTML = styleString;
  return { globalId, html: serializedGlobal.outerHTML };
};

export default updateCustomColorStylesheetInGlobal;
